var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Heading columns",class:{ 'is-gapless is-marginless': _vm.gapless }},[_c('div',{staticClass:"column"},[_c(_vm.computedTag,{tag:"component",staticClass:"title",class:_vm.extraTagClasses},[_vm._t("default",function(){return [_vm._v("[Heading]")]})],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }